import React, { Component } from 'react';

class Drawer extends Component {
    render() {
        const modal = {
            backgroundColor: 'rgba(0,0,0,0.3)',
            position: 'fixed',
            top: '0',
            right: '0',
            bottom: '0',
            left: '0',
            transition: 'visibility 0.4s',
            visibility: this.props.open ? 'visible' : 'hidden',
            zIndex: '1000'
        };

        const drawer = {
            background: '#373737',
            height: '100%',
            position: 'absolute',
            right: '0',
            width: this.props.open ? '60vw' : '0px',
            maxWidth: '400px',
            transition: 'width 0.5s',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start'
        };

        const children = {
            marginTop: '20px'
        };

        return (
            <div style={modal} onClick={this.props.onClick}>
                <div style={drawer}>
                    <div style={children}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    };
};

export default Drawer;


// WEBPACK FOOTER //
// ./src/components/Drawer.js